import { makeApiCall, ApiResponse } from "./index";

const BASE_URL = process.env.REACT_APP_API_CLIENT_URL;

// GET request
export function getTaxes(
  filters?: any,
  signal?: AbortSignal
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}taxes`, "GET", filters, null, signal);
}

// POST request
export function addTax(body?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}taxes`, "POST", body);
}

// PUT request
export function updateTax(TaxId: number, body?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}taxes/${TaxId}`, "PUT", body);
}

// DELETE request
export function deleteTax(TaxId: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}taxes/${TaxId}`, "DELETE");
}

// PATCH request
export function restoreTax(TaxId: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}taxes/${TaxId}`, "PATCH");
}

// GET request
export function getTax(TaxId: number | null | undefined): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}taxes/${TaxId}`, "GET");
}

// GET request - Get tax mappings
export function getTaxMappings(filters?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}taxes/mapping`, "GET", filters);
}

// POST request - Save tax mappings
export function saveTaxMappings(body?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}taxes/mapping`, "POST", body);
}

// POST request - fetch applicable taxes for a rate plan
export function getApplicableTaxes(
  assetRatePlanId: number,
  taxIds?: number[]
): Promise<ApiResponse> {
  const payload = {
    assetRatePlanId,
    taxIds: taxIds || [],
  };

  return makeApiCall(`${BASE_URL}taxes/ratePlan/applicable`, "POST", payload);
}
